module.exports = __webpack_public_path__ + "img/select-icon.819f54fc.jpeg";